<template>
	<v-dialog
		max-width="900"
		class="mx-auto"
		v-model="dialog"
	>
		<v-card

		>
			<v-toolbar class="px-3" dark color="#ed217c">
				<v-toolbar-title>{{ game.name }}</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn
					key="fetch"
					fab small
					target="_blank"
					color="primary"
					@click="callApi(options)"
				>
					<v-icon>mdi-reload</v-icon>
				</v-btn><v-btn
					class="mx-2"

					key="export"
					fab small
					target="_blank"
					color="success"
					:href="`api/game/${game.id}/scores/export`"
				>
					<v-icon>mdi-download</v-icon>
				</v-btn>
				<v-btn
					class="mx-2"
					key="delete"
					fab small
					color="warning"
					@click="deleteALL"
				>
					<v-icon>mdi-delete</v-icon>
				</v-btn>

			</v-toolbar>
			<v-card-title>
				<v-text-field
					v-model="search"
					append-icon="mdi-magnify"
					label="Search"
					single-line
					hide-details
				></v-text-field>
				<v-spacer/>

			</v-card-title>
			<v-data-table
				:headers="headers"
				:items="scores"
				:loading="loading"
				:server-items-length="totalItems"
				:options.sync="options"
				:multi-sort="false"
				class="elevation-1"
			>
				<v-progress-linear
					slot="progress"
					color="blue"
					indeterminate
				/>
			</v-data-table>
		</v-card>
	</v-dialog>
</template>

<script>
import { types } from "../../store/modules/Score.module";

export default {
	name: "GameDashboard",
	props: {
		game: Object,
		value: Boolean,
	},
	data () {
		return {
			loading: true,
			dataTable: {},
			search: "",
			totalItems:0,
			options: {
				itemsPerPage:15,
				mustSort:true,
			},
		};
	},
	computed: {
		dialog: {
			get () {
				return this.value;
			},
			set (val) {
				this.$emit("input", val);
			},
		},
		scores () {
			return this.$store.state.ScoreModule.scores.map((score) => {
				return Object.assign(score, { created_at: (new Date(score.created_at)).toLocaleString() });
			});
		},
		headers () {

			const baseHeader = [
				{
					name: "id",
					value: "id",
					text: "ID",
					sortable: true,
				},
				{
					name: "score",
					value: "score",
					text: "תוצאה",
					sortable: true,
				},
				{
					name: "time",
					value: "time",
					text: "משך זמן",
					sortable: true,
				},
				{
					name: "user_name",
					value: "user_name",
					text: "שם שחקן",
					sortable: true,
				},
				{
					name: "created_at",
					value: "created_at",
					dataType: "Date",
					text: "נוצר",
					sortable: true,
					format: (d) => (new Date(d)).toLocaleString("he"),
				},
			];
			const extraHeader = {};
			this.scores.forEach((score) => {
				Object.keys(score.extra).forEach((key) => {
					extraHeader[key] = {
						value: "extra." + key,
						text: key,
						sortable: true,
					};
				});
			});
			baseHeader.push(...Object.values(extraHeader));
			return baseHeader;
		},
	},
	methods: {
		async callApi (options={}) {
			this.loading = true;
			this.dataTable = await this.$store.dispatch(types.FETCH, { game: this.game.id ,filters: { ...options,filter:this.search }});
			this.totalItems = this.dataTable.total;
			this.loading = false;
		},
		async deleteALL(){
			let { isConfirmed } = await this.$notification.warning();
			if (isConfirmed) {
				this.loading = true;

				try {
					await this.$store.dispatch(types.REMOVE, this.game);
					await this.callApi(this.options);

				} catch (e) {
					console.log(e);
				}

				this.loading = false;
			}
		}
	},
	watch:{
		options: {
			handler () {
				this.callApi(this.options);
			},
			deep: true,
		},
		search: {
			handler () {
				this.callApi(this.options);
			},
			deep: true,
		},
	},
	async created () {
		await this.callApi();
	},
	mounted () {
		if (window.Echo) {
			window.Echo.private(`scores.${this.game.id}`)
				.listen("ScoreCreated", () => {
					this.callApi(this.options);
				});
		}
	}
};
</script>

<style scoped>

</style>
